export const environment = {
    production: false,
    apiServer: 'https://adminapi-dev.multibooking.net/api',
    adminPortal: 'https://admin-dev.multibooking.net/',
    mainWebsite: 'https://dev.multibooking.net/',
    name: 'dev'
};
